import {
    UPDATE_ITEM_INDEX,
    UPDATE_MODAL_STATUS,
    CLICK_INTRO_START_BUTTON,
    CLICK_BUTTON,
} from '../../actions/Modal';
import { compStatusTypes } from '../../Constants';

const initialState = {
    itemIndex: 0,
    status: compStatusTypes.HIDDEN,
};

export default function commonReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_ITEM_INDEX: {
            return Object.assign({}, state, {
                itemIndex: action.data,
            });
        }
        case UPDATE_MODAL_STATUS: {
            return Object.assign({}, state, {
                status: action.data,
            });
        }
        case CLICK_BUTTON: {
            const status = action.data.status || compStatusTypes.HIDDEN;
            return Object.assign({}, state, {
                status,
            });
        }
        case CLICK_INTRO_START_BUTTON: {
            return Object.assign({}, state, {
                status: compStatusTypes.HIDDEN,
            });
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./reducers/Modal/Modal.js